export default __webpack_public_path__ + "static/media/alert-dismissable-persistence.b30e97e9.svg";